var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ContentLayout", {
    attrs: {
      title: _vm.iSEdited
        ? _vm.$t("label_essweb_approvalTemplate_form_editTitle")
        : _vm.$t("label_essweb_approvalTemplate_form_viewTitle"),
      pad: "0",
      widthClass: "max-1000",
      delBtn: _vm.hasBtn("delete-admin-approval-template"),
      editBtn: !_vm.iSEdited && _vm.hasBtn("edit-admin-approval-template"),
      initData: _vm.approvalData,
      checkData: [
        "flow_template_status",
        "flow_template_name",
        "flow_template_description",
        "flow_type_uuid",
        "flow_template_code",
        "business_data_table_name",
        "effective_utc_datetime",
        "expired_utc_datetime",
        "remarks",
      ],
    },
    on: {
      change: function (changed) {
        return (_vm.isChanged = changed)
      },
      edit: function ($event) {
        _vm.iSEdited = true
      },
      delete: function ($event) {
        _vm
          .$confirmDo(_vm.$t("label_essweb_approvalTemplate_list_title"))
          .then(function (res) {
            res ? _vm.toDelete() : null
          })
      },
    },
    scopedSlots: _vm._u([
      {
        key: "page-main",
        fn: function () {
          return [
            _c("Taber", {
              attrs: { curTab: _vm.curTab, items: _vm.taber },
              on: {
                change: function (tab) {
                  return (_vm.curTab = tab)
                },
              },
              scopedSlots: _vm._u([
                {
                  key: "content-1",
                  fn: function () {
                    return [
                      _c(
                        "v-form",
                        { ref: "form", attrs: { "lazy-validation": "" } },
                        [
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "12",
                                    md: "12",
                                    lg: "12",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c("v-switch", {
                                    staticClass: "ml-4",
                                    attrs: {
                                      color: "primary",
                                      disabled: !_vm.iSEdited,
                                      label: _vm.approvalData
                                        .flow_template_status
                                        ? _vm.$t(
                                            "label_essweb_approvalTemplate_form_activeLabel"
                                          )
                                        : "",
                                    },
                                    model: {
                                      value:
                                        _vm.approvalData.flow_template_status,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.approvalData,
                                          "flow_template_status",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "approvalData.flow_template_status",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "12",
                                    md: "8",
                                    lg: "8",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c("inputTextFiledMultiLang", {
                                    attrs: {
                                      maxlength: "100",
                                      filled: _vm.iSEdited,
                                      readonly: !_vm.iSEdited,
                                      bindData:
                                        _vm.approvalData.flow_template_name,
                                      label: _vm.$t(
                                        "label_essweb_approvalTemplate_form_approvalTemplateNameLabel"
                                      ),
                                      rules: _vm.$GetRules(
                                        ["_Require_Rules"],
                                        [null]
                                      ),
                                    },
                                    on: {
                                      change: function (valueArr) {
                                        _vm.approvalData.flow_template_name =
                                          valueArr
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "12",
                                    md: "4",
                                    lg: "4",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c("normalInputTextFiled", {
                                    attrs: {
                                      label: _vm.$t(
                                        "label_essweb_ClaimReason_form_codeLabel"
                                      ),
                                      maxlength: "100",
                                      filled: _vm.iSEdited,
                                      readonly: !_vm.iSEdited,
                                      rules: _vm.$GetRules(
                                        ["_Require_Rules", "_Length_Rules"],
                                        [null, 100]
                                      ),
                                    },
                                    model: {
                                      value:
                                        _vm.approvalData.flow_template_code,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.approvalData,
                                          "flow_template_code",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "approvalData.flow_template_code",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "12",
                                    md: "12",
                                    lg: "12",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c("inputTextFiledMultiLang", {
                                    attrs: {
                                      filled: _vm.iSEdited,
                                      maxlength: "500",
                                      readonly: !_vm.iSEdited,
                                      bindData:
                                        _vm.approvalData
                                          .flow_template_description,
                                      label: _vm.$t(
                                        "label_essweb_approvalTemplate_form_descriptionLabel"
                                      ),
                                    },
                                    on: {
                                      change: function (valueArr) {
                                        _vm.approvalData.flow_template_description =
                                          valueArr
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "12",
                                    md: "12",
                                    lg: "12",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c(
                                    "v-sheet",
                                    {
                                      staticClass:
                                        "mrc_text_require text--secondary",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "label_essweb_approvalTemplate_form_approvalTemplateTypeLabel"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  _c("v-autocomplete", {
                                    attrs: {
                                      items: _vm.approvalType,
                                      "item-text": "flow_type_name",
                                      "item-value": "uuid",
                                      "single-line": "",
                                      rules: _vm.$GetRules(
                                        ["_Require_Rules"],
                                        [null]
                                      ),
                                      "menu-props": {
                                        offsetY: true,
                                        transition: "slide-y-transition",
                                        rounded: true,
                                        contentClass: "elevation-4",
                                      },
                                      filled: _vm.iSEdited,
                                      readonly: !_vm.iSEdited,
                                      label: _vm.$t(
                                        "label_essweb_approvalTemplate_form_approvalTemplateTypeLabel"
                                      ),
                                      dense: "",
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "no-data",
                                        fn: function () {
                                          return [_c("noContent")]
                                        },
                                        proxy: true,
                                      },
                                    ]),
                                    model: {
                                      value: _vm.approvalData.flow_type_uuid,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.approvalData,
                                          "flow_type_uuid",
                                          $$v
                                        )
                                      },
                                      expression: "approvalData.flow_type_uuid",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "12",
                                    md: "12",
                                    lg: "12",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c(
                                    "v-sheet",
                                    {
                                      staticClass:
                                        "mrc_text_require text--secondary",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "label_essweb_approvalTemplate_form_tableNameLabel"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  _c("v-autocomplete", {
                                    attrs: {
                                      "single-line": "",
                                      dense: "",
                                      disabled: "",
                                      filled: _vm.iSEdited,
                                      "item-text": "view_fields",
                                      "item-value": "value_field",
                                      placeholder: _vm.$t(
                                        "label_essweb_approvalTemplate_form_tableNameLabel"
                                      ),
                                      items: _vm.Tables,
                                      rules: _vm.$GetRules(
                                        ["_Require_Rules"],
                                        [null]
                                      ),
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "no-data",
                                        fn: function () {
                                          return [_c("noContent")]
                                        },
                                        proxy: true,
                                      },
                                      {
                                        key: "selection",
                                        fn: function (data) {
                                          return [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$getCommonLangValue(
                                                    data.item.view_fields
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        },
                                      },
                                      {
                                        key: "item",
                                        fn: function (data) {
                                          return [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "table-title text--primary",
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$getCommonLangValue(
                                                        data.item.view_fields
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                    ]),
                                    model: {
                                      value:
                                        _vm.approvalData
                                          .business_data_table_name,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.approvalData,
                                          "business_data_table_name",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "approvalData.business_data_table_name",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "6",
                                    md: "6",
                                    lg: "6",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c("DateTimePicker", {
                                    attrs: {
                                      rules: _vm.$GetRules(
                                        ["_Require_Rules"],
                                        [null]
                                      ),
                                      type: "date",
                                      defaultTime:
                                        _vm.approvalData.effective_utc_datetime,
                                      filled: _vm.iSEdited,
                                      label: _vm.$t(
                                        "label_essweb_approvalTemplate_form_effectiveDateLabel"
                                      ),
                                      readonly: !_vm.iSEdited,
                                      placeholder: "YYYY/MM/DD",
                                      max: _vm.approvalData
                                        .expired_utc_datetime,
                                    },
                                    on: {
                                      change: function (time) {
                                        _vm.approvalData.effective_utc_datetime =
                                          time
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "6",
                                    md: "6",
                                    lg: "6",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c("DateTimePicker", {
                                    attrs: {
                                      min: _vm.approvalData
                                        .effective_utc_datetime,
                                      type: "date",
                                      defaultTime:
                                        _vm.approvalData.expired_utc_datetime,
                                      filled: _vm.iSEdited,
                                      readonly: !_vm.iSEdited,
                                      label: _vm.$t(
                                        "label_essweb_approvalTemplate_form_expireDateLabel"
                                      ),
                                      placeholder: "YYYY/MM/DD",
                                    },
                                    on: {
                                      change: function (time) {
                                        _vm.approvalData.expired_utc_datetime =
                                          time
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "12",
                                    md: "12",
                                    lg: "12",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c(
                                    "v-sheet",
                                    { staticClass: "text--secondary" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "label_essweb_approvalTemplate_form_remarkLabel"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  _c("v-textarea", {
                                    attrs: {
                                      rows: "5",
                                      "no-resize": "",
                                      maxlength: "500",
                                      dense: "",
                                      counter: "500",
                                      "single-line": "",
                                      filled: _vm.iSEdited,
                                      readonly: !_vm.iSEdited,
                                    },
                                    model: {
                                      value: _vm.approvalData.remarks,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.approvalData,
                                          "remarks",
                                          $$v
                                        )
                                      },
                                      expression: "approvalData.remarks",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "content-2",
                  fn: function () {
                    return [
                      _c(
                        "draggable",
                        _vm._b(
                          {
                            staticClass: "from_content",
                            attrs: { draggable: ".drag", disabled: true },
                            model: {
                              value: _vm.dragArr,
                              callback: function ($$v) {
                                _vm.dragArr = $$v
                              },
                              expression: "dragArr",
                            },
                          },
                          "draggable",
                          { animation: 1000 },
                          false
                        ),
                        _vm._l(_vm.NodeList, function (item, index) {
                          return _c(
                            "v-sheet",
                            {
                              key: index,
                              staticClass:
                                "drag transparent d-flex flex-grow-1 ma-3 align-center",
                            },
                            [
                              _c(
                                "v-avatar",
                                {
                                  attrs: {
                                    color: "primary  white--text",
                                    size: "40",
                                  },
                                },
                                [
                                  _c("span", { staticClass: "headline" }, [
                                    _vm._v(_vm._s(item.number + 1)),
                                  ]),
                                ]
                              ),
                              _c("v-hover", {
                                attrs: { "open-delay": "100" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (ref) {
                                        var hover = ref.hover
                                        return [
                                          _c(
                                            "v-card",
                                            {
                                              staticClass:
                                                "\n                  white\n                  d-flex\n                  flex-row\n                  justify-space-around\n                  flex-grow-1\n                  ml-3\n                  pa-2\n                  align-center\n                ",
                                              attrs: {
                                                elevation: hover ? 10 : 2,
                                              },
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$getCommonLangValue(
                                                        item.flow_template_node_name
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]),
                                              _c("v-spacer"),
                                              _c(
                                                "div",
                                                [
                                                  _vm.iSEdited
                                                    ? _c(
                                                        "v-btn",
                                                        {
                                                          staticClass: "ma-2",
                                                          attrs: {
                                                            icon: "",
                                                            small: "",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              _vm.curNodeUuid =
                                                                item.uuid
                                                              _vm.showEditApprovalDialog = true
                                                              _vm.curNumber =
                                                                item.number
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "material-icons-round",
                                                            },
                                                            [_vm._v("edit")]
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm.iSEdited
                                                    ? _c(
                                                        "v-btn",
                                                        {
                                                          staticClass: "ma-2",
                                                          attrs: {
                                                            icon: "",
                                                            small: "",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.toDeleteNode(
                                                                item.uuid
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "material-icons-round",
                                                            },
                                                            [_vm._v("delete")]
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                            ],
                            1
                          )
                        }),
                        1
                      ),
                      _vm.iSEdited
                        ? _c(
                            "v-btn",
                            {
                              staticClass: "text-capitalize",
                              attrs: { text: "", color: "primary", small: "" },
                              on: {
                                click: function ($event) {
                                  _vm.showNewApprovalDialog = true
                                },
                              },
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "material-icons-round" },
                                [_vm._v("add")]
                              ),
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "label_essweb_approvalTemplate_form_node_addNodeBtnLabel"
                                  )
                                ) + " "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]
                  },
                  proxy: true,
                },
              ]),
            }),
          ]
        },
        proxy: true,
      },
      {
        key: "page-actions",
        fn: function () {
          return [
            _vm.iSEdited && _vm.curTab == "tab-1"
              ? _c("CardActions", {
                  attrs: { saveBtn: _vm.curTab == "tab-1" },
                  on: {
                    save: _vm.toSave,
                    cancel: function ($event) {
                      return _vm.$toBack(_vm.isChanged)
                    },
                  },
                })
              : _vm._e(),
          ]
        },
        proxy: true,
      },
      {
        key: "tools-main",
        fn: function () {
          return [
            _c("newApprovalDialog", {
              attrs: {
                show: _vm.showNewApprovalDialog,
                allNode: _vm.NodeList,
                table: _vm.approvalData.business_data_table_name,
              },
              on: {
                close: function ($event) {
                  _vm.showNewApprovalDialog = false
                  _vm.NodePropertyData = null
                },
                onNew: _vm.onNewNode,
              },
            }),
            _c("editApprovalDialog", {
              attrs: {
                show: _vm.showEditApprovalDialog,
                online: "",
                allNode: _vm.NodeList.filter(function (ele) {
                  return ele["number"] <= Number(_vm.curNumber)
                }),
                PropertyData: _vm.NodePropertyData,
                curUuid: _vm.curNodeUuid,
                table: _vm.approvalData.business_data_table_name,
              },
              on: {
                close: function ($event) {
                  _vm.showEditApprovalDialog = false
                  _vm.NodePropertyData = null
                  _vm.curNodeUuid = null
                  _vm.curNumber = null
                },
                onEdit: _vm.onEditNode,
              },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }